import { Header } from '@/components/layout/Header';
import { PageContainer } from '@/components/layout/Layout';
import { useI18n } from '@/i18n';
import { ArrowLeft, FileText } from 'lucide-react';
import { useNavigate } from 'react-router-dom';

interface LegalPageProps {
  titleKey: string;
  contentKey: string;
}

function LegalPage({ titleKey, contentKey }: LegalPageProps) {
  const navigate = useNavigate();
  
  const { t } = useI18n();
  return (
    <>
      <Header
        title={t(titleKey)}
        icon={
          <div className="w-9 h-9 rounded-xl bg-indigo-100 dark:bg-indigo-900/40 flex items-center justify-center">
            <FileText size={18} className="text-indigo-600 dark:text-indigo-400" />
          </div>
        }
      />
      <button
        onClick={() => navigate('/settings')}
        className="ml-2 mt-3 inline-flex items-center gap-1.5 text-sm text-slate-500 hover:text-brand-600 dark:text-slate-400 dark:hover:text-brand-400 bg-white/70 dark:bg-slate-800/70 backdrop-blur px-3 py-2 rounded-xl shadow-sm "
      >
        <ArrowLeft size={16} /> {t('common.back')}
      </button>
      <PageContainer>
        <div className="prose prose-sm dark:prose-invert max-w-none text-slate-700 dark:text-slate-300">
          {/* Il contenuto viene reso come paragrafi separati da '\\n\\n' nella traduzione */}
          {t(contentKey).split('\n\n').map((paragraph: string, i: number) => (
            <p key={i} className="mb-4">{paragraph}</p>
          ))}
        </div>
      </PageContainer>
    </>
  );
}

export default LegalPage;